import { Component, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap, shareReplay } from 'rxjs/operators';
import { AppyUser } from 'src/app/core/model/v2/AppyUser';
import { GlobalHealthSystem } from 'src/app/core/model/v2/healthSystem/global-health-system';
import { PhysicianPractice } from 'src/app/core/model/v2/practitioner/physicianPractice';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
const REFRESH_INTERVAL = 3600000;

@Component({
  selector: 'app-call-center-header-filter',
  templateUrl: './call-center-header-filter.component.html',
  styleUrls: ['./call-center-header-filter.component.scss']
})
export class CallCenterHeaderFilterComponent implements OnInit {

  selectedPhysicianPractice: PhysicianPractice;
  physicianPractices: PhysicianPractice[];

  selectedHealthSystem: GlobalHealthSystem;
  healthSystems: GlobalHealthSystem[];

  // userId: number;
  isPhysician: boolean = false;

  constructor(private practiceService: PracticeService, private userService: UserService, private physicianOptionService: PhysicianOptionService) { }

  ngOnInit() {
    
    this.getServiceInit();
    // const userStorage = localStorage.getItem('userDetails');
    // if(!userStorage){
    //   this.getServiceInit();
    // }
    // else {
    //   const userJson = JSON.parse(userStorage);
    //   const physicianPracticesJson = JSON.parse(localStorage.getItem('physicianPractices'));
    //   this.setInit(userJson, physicianPracticesJson);
    // }
  }

  cachedUserDetail$: Observable<AppyUser>;
  cachedHealthSystem$: Observable<any>;

  private getUserDetailCached(): Observable<AppyUser> {
    if (!this.cachedUserDetail$) {
      const timer$ = timer(0, REFRESH_INTERVAL);
      this.cachedUserDetail$ = timer$.pipe(
        switchMap(_ => this.userService.getUserDetails()),
        shareReplay(50)
      );
    }
    return this.cachedUserDetail$;
  }

  private getHealthSystemCached(userId: number): Observable<AppyUser> {
    if (!this.cachedHealthSystem$) {
      const timer$ = timer(0, REFRESH_INTERVAL);
      this.cachedHealthSystem$ = timer$.pipe(
        switchMap(_ => this.practiceService.getAllHealthSystemAndPractitionersByUserID(userId)),
        shareReplay(50)
      );
    }
    return this.cachedHealthSystem$;
  }

  private getServiceInit() {
    this.getUserDetailCached().subscribe(
      (userDetails) => {
        // localStorage.setItem('userDetails', JSON.stringify(userDetails));
        this.getHealthSystemCached(userDetails.id).subscribe(
          (res) => {
            // localStorage.setItem('physicianPractices', JSON.stringify(res));
            this.setInit(userDetails, res);
          },
          (error) => { console.error(error); });
      },
      (error) => { console.error(error); });
  }

  private setInit(userResponse: AppyUser, practiceResponse) {

    if (practiceResponse && practiceResponse['response']['isSuccess']) {
      if (userResponse.role === "Physician") {
        this.isPhysician = true;
        this.physicianPractices = practiceResponse.physician.filter(m => {
          return m.id == userResponse.practitionerId;
        });
      }
      else {
        this.physicianPractices = practiceResponse['physician'];
      }

      if (this.physicianPractices.length > 0) {

        this.tryToRecoverTheLastPhysicianSelected();

        if (this.selectedPhysicianPractice.healthSystems && this.selectedPhysicianPractice.healthSystems.length > 0) {
          this.tryToRecoverTheLastHealthSystemSelected()
          this.physicianOptionService.setOptions(this.selectedPhysicianPractice, this.selectedHealthSystem);
        } else {
          this.physicianOptionService.setPhysician(this.selectedPhysicianPractice);
        }
      }
    }

  }

  private tryToRecoverTheLastPhysicianSelected() {
    let lastSelectedPhysician = this.physicianOptionService.getPhysician();

    let selected = this.physicianPractices.find(p => p.id == lastSelectedPhysician.id);
    if (selected) {
      this.selectedPhysicianPractice = selected;
    }

    else {
      this.selectedPhysicianPractice = this.physicianPractices[0];
    }
  }

  private tryToRecoverTheLastHealthSystemSelected() {
    let lastSelectedHealthSystem = this.physicianOptionService.getHealthSystem();

    let selected = this.selectedPhysicianPractice.healthSystems.find(p => p.id == lastSelectedHealthSystem.id);
    if (selected) {
      this.selectedHealthSystem = selected;
    }
    else {
      this.selectedHealthSystem = this.selectedPhysicianPractice.healthSystems[0];
    }
  }

  physicianSelect(selected: PhysicianPractice) {
    if(!this.isPhysician){
    this.selectedPhysicianPractice = selected;
    this.selectedHealthSystem = this.selectedPhysicianPractice.healthSystems[0];
    this.physicianOptionService.setOptions(this.selectedPhysicianPractice, this.selectedHealthSystem);
    }
  }

  locationSelect(selected: GlobalHealthSystem) {
    this.selectedHealthSystem = selected;
    this.physicianOptionService.setOptions(this.selectedPhysicianPractice, this.selectedHealthSystem);
  }

}
